import useSWR from "swr";

import LandingPagePartners from "~/components/LandingPagePartners";

const AboutPartners = () => {
	const { data: partners } = useSWR("/company-info/partners");
	const { data: customers } = useSWR("/company-info/customers");

	return <LandingPagePartners partners={partners} customers={customers} />;
};

export default AboutPartners;
